module.exports = __webpack_public_path__ + "img/yl3036.0f64fb11.png";